module.exports = __webpack_public_path__ + "static/media/ExcelIcon.b0a7f2a5.svg";